var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"slider",attrs:{"step":_vm.step,"min":_vm.min,"max":_vm.max,"type":"range"},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }